import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, IdCardIcon } from 'lucide-react';
const credentials = ['Resident', 'Pool', 'Registered activity', 'Facility access', 'Booking'];
export function CardAccess() {
  return <section aria-labelledby="card-access-title" className="mt-14 grid gap-6 rounded-3xl border border-slate-200 bg-white p-6 sm:p-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,320px)] lg:items-center" data-id="element-1406" data-mp="b0jbs8uhu5vf">
      <div data-id="element-1407" data-mp="15hntgbyf9uf">
        <h2 id="card-access-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1408" data-mp="159bpqnno8ka">
          My digital card
        </h2>
        <p className="mt-2 max-w-xl text-[15px] leading-relaxed text-slate-600" data-id="element-1409" data-mp="3o8dzhv74yhvn">
          Your card gets you into your activities and participating facilities. No separate recreation card is needed.
        </p>
        <ul className="mt-4 flex flex-wrap gap-2" data-id="element-1410" data-mp="1mhj3b290ogoe">
          {credentials.map(credential => <li key={credential} className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-ville-navy" data-id="element-1411" data-mp="1hify9ht1eagf">
              {credential}
            </li>)}
        </ul>
        <Link to="/my-card" className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-ville-indigo hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1412" data-mp="1n57lbo4ufrw7">
          View my card
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1413" data-mp="1i3rxxpf719an" />
        </Link>
      </div>

      <div className="rounded-2xl bg-ville-navy p-5 text-white" data-id="element-1414" data-mp="25tm81z84ojr7">
        <div className="flex items-center justify-between" data-id="element-1415" data-mp="25ue57ehdipjl">
          <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em]" data-id="element-1416" data-mp="2asywgoendyvw">
            <IdCardIcon className="h-4 w-4 text-ville-lime" aria-hidden="true" data-id="element-1417" data-mp="1w4kuefp22ege" />
            Digital card
          </span>
          <span className="text-xs font-semibold text-white/60" data-id="element-1418" data-mp="211bah30v1a1t">Bonnyville</span>
        </div>
        <p className="mt-6 text-lg font-extrabold" data-id="element-1419" data-mp="2oroty55dq0ks">Bryon Mickelson</p>
        <p className="font-mono text-sm tracking-[0.2em] text-white/70" data-id="element-1420" data-mp="2tjp1ojroxxrx">•••• •••• 4127</p>
      </div>
    </section>;
}